import React from 'react';
export function ProgramsCurriculum() {
  return <section className="py-20 bg-[#111]" data-id="element-1586">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1587">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-1588">
          <div className="animate-scroll-fade-up" data-id="element-1589">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1590">
              Why Choose Our Curriculum?
            </h2>
            <div className="space-y-6 text-gray-300" data-id="element-1591">
              <p data-id="element-1592">
                Our curriculum is built on decades of experience, blending
                traditional martial arts values with modern teaching
                methodologies. We don't just teach you how to kick and punch; we
                teach you how to succeed in life.
              </p>
              <p data-id="element-1593">
                Each program is structured with clear goals and progression
                paths, ensuring that every student experiences a sense of
                achievement as they advance through the ranks.
              </p>
              <ul className="space-y-3 mt-6" data-id="element-1594">
                {['Certified Instructors', 'Age-Appropriate Classes', 'Safe Training Environment', 'Personalized Attention'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-1595">
                    <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-1596" />
                    <span className="text-white font-medium" data-id="element-1597">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="animate-scroll-scale-in relative h-[400px] rounded-2xl overflow-hidden" style={{
          animationDelay: '0.2s'
        }} data-id="element-1598">
            <img src="https://cdn.magicpatterns.com/uploads/r1PvQh63JZazBt1NNyhiwx/programs.jpg" alt="Instructor teaching students" className="w-full h-full object-cover" data-id="element-1599" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-1600" />
          </div>
        </div>
      </div>
    </section>;
}